/* WAVE cart reassurance block.
   Shows on the cart page AND in the slide-out cart drawer.

   ===================================================================
   READ THIS BEFORE CHANGING THRESHOLD. 15 September 2026.

   THRESHOLD is the number WAVE ADVERTISES. It is deliberately HIGHER
   than the number Shopify actually applies. That is not a mistake and
   it must not be "corrected".

   Advertised everywhere on the site: free UK delivery over 100.
   Set in Shopify: free UK delivery from 80.

   WHY. Shopify tests its free delivery rule against the basket total
   AFTER any discount. Trade accounts get up to 20% off. A trade
   customer who genuinely spends 100 at full price pays 80, and at a
   threshold of 100 Shopify would charge them 4.99 on an order they
   were promised free delivery on. Setting Shopify to 80 covers 20% off
   a 100 order exactly, so the promise is always kept.

   The gap only ever works in the customer's favour. Someone whose
   basket lands between 80 and 100 is told delivery costs 4.99 and then
   gets it free at checkout. A pleasant surprise. The reverse, promising
   free and then charging, can never happen.

   IF YOU CHANGE THE ADVERTISED NUMBER, change all of these together:
     - THRESHOLD below
     - the free shipping line in injectDrawerCSS() below
     - the PRODUCT DETAILS tab in templates/product.json
     - the Shipping policy in Shopify admin
     - the collection descriptions that state it: frontpage, shampoo,
       hair-brushes, shop-all-hair-care, shop-all-professional-tools
     - the Shopify delivery rate, keeping it at 80% of the advertised
       figure so the trade discount stays covered
   =================================================================== */
(function () {
  var THRESHOLD = 100;     // the number WAVE advertises. See the note above.
  var SHIP_COST = '4.99';  // UK delivery charge below the threshold

  /* WAVE 15 Sep 2026 - two cosmetic changes to the slide-out cart, asked
     for by Daniel. Both are done from here rather than by editing
     sections/mini_cart.liquid, so that theme file stays untouched and all
     of this can be undone by deleting this one function.

     1. The drawer had three tabs across the top: a wishlist heart, a
        recently viewed eye, and the cart. The first two are hidden. They
        are hidden rather than deleted so nothing in the theme breaks. The
        cart tab is picked out by data-is-tab-cart, an attribute only it
        carries, so this does not depend on the order of the tabs.

     2. The line under the subtotal read only "Tax included." It now also
        states the free delivery threshold. Written with ::after so it
        survives the theme re-rendering the drawer, which happens on every
        cart change. */
  function injectDrawerCSS() {
    if (document.getElementById('wave-drawer-css')) return;
    var css = document.createElement('style');
    css.id = 'wave-drawer-css';
    css.textContent =
      '#t4s-mini_cart .t4s-minicart-tabs-item:not([data-is-tab-cart]){display:none !important;}' +
      '#t4s-mini_cart .t4s-minicart-tabs-item[data-is-tab-cart]{flex:1 1 100% !important;}' +
      '.t4s-cart__tax::after{content:" Free UK shipping over £100.";}';
    (document.head || document.documentElement).appendChild(css);
  }
  injectDrawerCSS();

  var CART_SELECTORS = [
    'form[action^="/cart"]',
    '.t4s-cart__items',
    '#MainContent',
    'main'
  ];

  var DRAWER_SELECTORS = [
    '#t4s-mini_cart .t4s-mini_cart__items',
    '#t4s-mini_cart .t4s-drawer__body',
    '.t4s-mini_cart__items',
    '#t4s-mini_cart form',
    '#t4s-mini_cart'
  ];

  function pick(list) {
    for (var i = 0; i < list.length; i++) {
      var el = document.querySelector(list[i]);
      if (el) return el;
    }
    return null;
  }

  function money(n) { return Number(n).toFixed(2); }

  /* WAVE 14 Sep 2026 - dispatch line now matches the product page banners.
     Made to order cannot be detected from /cart.js, because Shopify's cart
     JSON carries `available` but never `inventory_quantity`. So each cart
     line is stamped with data-wave-mto from Liquid in cart-item.liquid, and
     we aggregate here. The slowest item sets the date, because the whole
     order goes out as one parcel.
     The date strings come from window.WAVE_DISPATCH_TEXT, defined by
     snippets/wave-dispatch-dates.liquid, which is rendered site wide from
     layout/theme.liquid. Same single source of truth as the product page. */
  function dispatchHTML() {
    var nodes = document.querySelectorAll('[data-wave-mto]');
    var mto = 0, ins = 0, i;
    for (i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-wave-mto') === 'true') { mto++; } else { ins++; }
    }

    var T = window.WAVE_DISPATCH_TEXT || {};
    var line = 'font-size:12.5px;font-weight:600;letter-spacing:0.2px;margin:0 0 10px;line-height:1.5;';
    var note = 'font-size:10.5px;color:#777;letter-spacing:0.6px;text-transform:uppercase;margin:-6px 0 10px;line-height:1.5;';

    /* Cart contents not rendered yet, so fall back to wording that is true
       either way rather than guessing a date. */
    if (nodes.length === 0) {
      return '<p style="font-size:11px;color:#666;letter-spacing:0.8px;text-transform:uppercase;margin:0 0 10px;line-height:1.5;">' +
             'Dispatch depends on what is in your basket. In stock items go out the next working day, made to order items 15 days from the day you order.</p>';
    }

    if (mto > 0) {
      var html = '<p style="' + line + 'color:#8a6d1f;">' +
                 (T.madeToOrder || 'Made to order, dispatched in 15 days') + '</p>';
      if (ins > 0) {
        html += '<p style="' + note + '">Your whole order ships together</p>';
      }
      return html;
    }

    return '<p style="' + line + 'color:#222;">' +
           (T.instock || '✓ Dispatches next working day') + '</p>';
  }

  function buildHTML(total, compact) {
    var delivery;
    if (total >= THRESHOLD) {
      delivery = '<p style="font-size:15px;color:#1a7f37;font-weight:600;margin:0 0 8px;">&#10003; Free UK delivery on this order</p>';
    } else {
      delivery = '<p style="font-size:15px;color:#222;font-weight:600;margin:0 0 8px;">UK delivery &pound;' + SHIP_COST +
                 '. Spend &pound;' + money(THRESHOLD - total) + ' more for free UK delivery.</p>';
    }

    var dispatch = dispatchHTML();

    var tick = '<span style="color:#a8946f;font-weight:700;margin-right:5px;">&#10003;</span>';
    var itemStyle = 'font-size:12px;color:#333;line-height:1.45;margin:0;';
    var reassure =
      '<div style="border-top:1px solid #e8e2d9;padding-top:10px;margin-bottom:10px;display:flex;gap:14px;flex-wrap:wrap;justify-content:center;text-align:left;">' +
        '<p style="' + itemStyle + '">' + tick + 'Free colour and texture match before you order</p>' +
        '<p style="' + itemStyle + '">' + tick + 'Card, Apple Pay, Google Pay and Klarna</p>' +
        '<p style="' + itemStyle + '">' + tick + 'UK based, real people if you are unsure</p>' +
      '</div>';

    var klarna = '<p style="font-size:12.5px;color:#555;margin:0;">or 3 interest-free payments of ' +
                 '<b style="color:#000;">&pound;' + money(total / 3) + '</b> with ' +
                 '<span style="background:#FFB3C7;color:#000;font-weight:700;font-size:11px;padding:2px 7px;border-radius:4px;font-style:italic;display:inline-block;line-height:1.4;">Klarna</span></p>';

    return compact ? (delivery + dispatch + klarna) : (delivery + dispatch + reassure + klarna);
  }

  function paint(host, total, cls, compact) {
    if (!host) return;
    var old = host.parentNode ? host.parentNode.querySelector('.' + cls) : null;
    if (!old) old = document.querySelector('.' + cls);
    if (old && old.parentNode) old.parentNode.removeChild(old);
    if (!total || total <= 0) return;

    var box = document.createElement('div');
    box.className = cls;
    box.setAttribute('data-wave-total', String(total));
    box.style.cssText = 'background:#faf8f5;border:1px solid #ececec;border-radius:10px;padding:' +
      (compact ? '12px 14px' : '14px 16px') + ';margin:0 0 18px;text-align:center;';
    box.innerHTML = buildHTML(total, compact);
    host.insertBefore(box, host.firstChild);
  }

  /* WAVE 15 Sep 2026 - one reassurance line sitting directly above the
     checkout button, in the drawer and on the cart page.
     Two different containers, because the theme uses two:
       drawer    -> .t4s-minicart-group-btns   (sections/mini_cart.liquid)
       cart page -> .t4s-btn-group__checkout-update (sections/main-cart.liquid)
     Both were read from the theme, neither is a guess. If neither is on the
     page we do nothing rather than inventing an insertion point. */
  var SECURE_CLS = 'wave-secure-line';

  var SECURE_TARGETS = [
    { sel: '#t4s-mini_cart .t4s-minicart-group-btns', scope: 'drawer' },
    { sel: '.t4s-btn-group__checkout-update',         scope: 'cart' }
  ];

  /* Padlock drawn inline rather than as the &#128274; entity. The entity
     renders as a full colour emoji, which fights a black, white and serif
     brand. This one inherits the line's grey through currentColor. */
  function secureLineHTML() {
    return '<svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true" focusable="false" ' +
             'style="vertical-align:-1px;margin-right:5px;">' +
             '<path d="M3.75 5.25V3.75a2.25 2.25 0 0 1 4.5 0v1.5" fill="none" stroke="currentColor" stroke-width="1.1"/>' +
             '<rect x="2.25" y="5.25" width="7.5" height="5.25" rx="1" fill="currentColor"/>' +
           '</svg>' +
           'Secure checkout, handled by Shopify. We never see your card details.';
  }

  function paintSecure(btns, scope) {
    if (!btns || !btns.parentNode) return;

    /* Same belt and braces as paint(): clear the scoped one first, then any
       stray one left anywhere, so the line can never double up. */
    var old = btns.parentNode.querySelector('.' + SECURE_CLS + '[data-wave-scope="' + scope + '"]');
    if (!old) old = document.querySelector('.' + SECURE_CLS + '[data-wave-scope="' + scope + '"]');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var line = document.createElement('p');
    line.className = SECURE_CLS;
    line.setAttribute('data-wave-scope', scope);
    line.style.cssText = 'font-size:12px;line-height:1.4;color:#777;text-align:center;margin:0 0 8px;';
    line.innerHTML = secureLineHTML();
    btns.parentNode.insertBefore(line, btns);
  }

  function paintSecureAll() {
    for (var i = 0; i < SECURE_TARGETS.length; i++) {
      var t = SECURE_TARGETS[i];
      var btns = document.querySelector(t.sel);
      if (btns) paintSecure(btns, t.scope);
    }
  }

  /* WAVE 17 Sep 2026 - the guarantee, directly below the checkout button.

     WHY BELOW AND NOT ABOVE
     The line above the button answers "is my card safe". This one answers
     "what if the hair is wrong", which is the question people are still
     holding as they press the button, so it wants to be the last thing they
     read rather than the first.

     TWO DIFFERENT INSERTION POINTS, because the two containers are built
     differently. Both were read off the live site on 17 Sep 2026, neither
     is a guess:

       drawer     .t4s-minicart-group-btns is display:block and holds the
                  checkout button, so the line is appended INSIDE it. The
                  card icons (.wave-pay-row, drawn by
                  assets/wave-cart-payments.js) are a SIBLING of that
                  container, so they stay underneath and nothing can get
                  between the button and this line.

       cart page  .t4s-btn-group__checkout-update is inline-flex laid out in
                  a row. Appending inside would put the line beside the
                  button, so it goes immediately AFTER the container
                  instead, which puts it above the card icons.

     Because this repaints on the same events as the secure line, a card
     icon row drawn after us is corrected on the next repaint rather than
     left sitting in the wrong place.

     THE WORDING IS A PROMISE TO A CUSTOMER, so it lives on exactly one line
     in this file and nowhere else. Change GUARANTEE_TEXT and both the
     drawer and the cart page change together. */
  var GUARANTEE_CLS = 'wave-guarantee-line';
  var GUARANTEE_TEXT = '30-day money-back guarantee';

  /* Shield with a tick, drawn inline for the same reason as the padlock
     above: an emoji renders in full colour and fights a black and white
     brand. This inherits the line's colour through currentColor. */
  function guaranteeHTML() {
    return '<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true" focusable="false" ' +
             'style="vertical-align:-2px;margin-right:6px;">' +
             '<path d="M7 1.2l4.6 1.9v3.6c0 2.7-1.9 5.1-4.6 5.7-2.7-.6-4.6-3-4.6-5.7V3.1z" ' +
               'fill="none" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/>' +
             '<path d="M4.9 7.1l1.5 1.5 2.7-2.9" fill="none" stroke="currentColor" ' +
               'stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
           '</svg>' + GUARANTEE_TEXT;
  }

  function paintGuarantee(btns, scope) {
    if (!btns || !btns.parentNode) return;

    /* Clear any previous one anywhere on the page before drawing, so the
       line can never double up after a re-render. Same guard as paintSecure. */
    var old = document.querySelector('.' + GUARANTEE_CLS + '[data-wave-scope="' + scope + '"]');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var line = document.createElement('p');
    line.className = GUARANTEE_CLS;
    line.setAttribute('data-wave-scope', scope);
    line.style.cssText = 'margin:10px 0 0;font-size:12px;line-height:1.4;font-weight:600;' +
                         'text-align:center;color:#222;letter-spacing:.01em;';
    line.innerHTML = guaranteeHTML();

    if (scope === 'drawer') {
      btns.appendChild(line);
    } else {
      /* On the cart page the card icons (.wave-pay-row, drawn by
         assets/wave-cart-payments.js) are a SIBLING of the button container
         rather than a child of it, so simply going after the container puts
         this line underneath the icons. Going in front of the icons is what
         puts it directly under the button.
         Checked on the live site 17 Sep 2026: once drawn, that icon row does
         not reposition itself, so it will not leapfrog back over this line. */
      var pay = btns.parentNode.querySelector('.wave-pay-row');
      btns.parentNode.insertBefore(line, pay || btns.nextSibling);
    }
  }

  function paintGuaranteeAll() {
    for (var i = 0; i < SECURE_TARGETS.length; i++) {
      var t = SECURE_TARGETS[i];
      var btns = document.querySelector(t.sel);
      if (btns) paintGuarantee(btns, t.scope);
    }
  }

  /* =================================================================
     WAVE 15 Sep 2026 - FIX: the basket total must always be re-read.

     THE BUG, as reported and then reproduced on the live site.
     A customer added hair extensions, took them out, and put a small
     haircare item in. The basket still told them "Free UK delivery on this
     order" on a 12.99 basket. Done the other way round it told them
     "UK delivery 4.99" on a basket well over the threshold.

     TWO CAUSES, both in this file.

     1. This file listened for 'cart:updated' and 'cart:refresh'.
        This theme fires neither. Watching every event dispatched on a live
        product page shows the theme fires 'cart:update:count'. So both
        listeners were dead code and nothing ever re-read the basket.

     2. The MutationObserver below repainted from a remembered variable,
        lastTotal, instead of re-reading the basket. So even when it did
        redraw, it redrew the figure from the last full page load.

     Shopify's own delivery rates were never wrong. Nobody was ever charged
     the wrong amount at checkout. Only this message was wrong, which is
     still serious, because it is the promise the customer reads before
     they pay.

     THE RULE NOW: every repaint re-reads /cart.js. There is no remembered
     total anywhere in this file. If the basket cannot be read, nothing is
     repainted, rather than a stale figure being shown.
     ================================================================= */

  var inflight = false;   /* a fetch is in the air */
  var queued   = false;   /* something changed while it was in the air */

  function load() {
    if (inflight) { queued = true; return; }
    inflight = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = (cart.total_price || 0) / 100;
        if (document.body.classList.contains('template-cart')) {
          paint(pick(CART_SELECTORS), total, 'wave-cart-notices', false);
        }
        paint(pick(DRAWER_SELECTORS), total, 'wave-drawer-notices', true);
        paintSecureAll();
        paintGuaranteeAll();
      })
      .catch(function () { /* leave whatever is on screen rather than guess */ })
      .then(function () {
        inflight = false;
        if (queued) { queued = false; setTimeout(load, 120); }
      });
  }

  function boot() { setTimeout(load, 300); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* 'cart:update:count' is the one this theme actually fires, confirmed by
     watching dispatchEvent on a live product page on 15 Sep 2026. The rest
     are kept because other Shopify apps fire them, they cost nothing, and
     the in-flight guard above means duplicates cannot stack up. */
  var CART_EVENTS = ['cart:update:count', 'cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'cart:build'];
  for (var e = 0; e < CART_EVENTS.length; e++) {
    document.addEventListener(CART_EVENTS[e], function () { setTimeout(load, 350); });
  }

  /* Second line of defence. When the theme replaces the drawer contents it
     takes our box out with them. Seeing it missing means the basket changed,
     so re-read and redraw. This used to redraw from lastTotal, which is what
     produced the wrong message. It now calls load(). */
  var pending = null;
  var observer = new MutationObserver(function () {
    var missingSecure = false;
    for (var i = 0; i < SECURE_TARGETS.length; i++) {
      var t = SECURE_TARGETS[i];
      var btns = document.querySelector(t.sel);
      if (btns && btns.parentNode &&
          !btns.parentNode.querySelector('.' + SECURE_CLS + '[data-wave-scope="' + t.scope + '"]')) {
        missingSecure = true;
      }
    }

    var drawer = pick(DRAWER_SELECTORS);
    var missingNotices = !!drawer && !drawer.querySelector('.wave-drawer-notices');

    /* The guarantee is checked separately from the secure line. They sit in
       different places, so the theme can take one out and leave the other. */
    var missingGuarantee = false;
    for (var j = 0; j < SECURE_TARGETS.length; j++) {
      var tg = SECURE_TARGETS[j];
      var bg = document.querySelector(tg.sel);
      if (bg && !document.querySelector('.' + GUARANTEE_CLS + '[data-wave-scope="' + tg.scope + '"]')) {
        missingGuarantee = true;
      }
    }

    if (!missingSecure && !missingGuarantee && !missingNotices) return;
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      paintSecureAll();
      paintGuaranteeAll();
      if (missingNotices) load();
    }, 250);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
